/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Papers_OnlyInputs */

const en_why_listening_papers_only = /** @type {(inputs: Why_Listening_Papers_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Papers only`)
};

const es_why_listening_papers_only = /** @type {(inputs: Why_Listening_Papers_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo artículos`)
};

/**
* | output |
* | --- |
* | "Papers only" |
*
* @param {Why_Listening_Papers_OnlyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_papers_only = /** @type {((inputs?: Why_Listening_Papers_OnlyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Papers_OnlyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_papers_only(inputs)
	return en_why_listening_papers_only(inputs)
});